import React, {useEffect, useRef, useState} from "react";
import styles from "./generation-type.module.css";
import texts from "../../assets/ContextProvider/textsLocalized.json";
import {useNavigate} from "react-router-dom";
import Routes from "../../assets/Routes/Routes.jsx";
import ServerRequest from "../../serverRequests/ServerRequest";
import {getGeneratedMovies} from "../../store/slices/generatedMovie";
import {useDispatch} from "react-redux";
import Loader from "../../components/Loader/Loader";
import {scrollToTop} from "../../assets/AdditionalFunctions/ScrollToTop";
import {animateButtonPress} from "../../assets/AdditionalFunctions/AnimateButtonPress";


const genres = {
  tv: [
    'Action & Adventure',
    'Animation',
    'Reality',
    'Comedy',
    'Crime',
    'Documentary',
    'Drama',
    'Family',
    'Sci-Fi & Fantasy',
    'War & Politics',
    'Mystery',
    'News',
    'Talk',
    'Kids',
    'Soap',
    'Western'
  ],
  movie: [
    'Action',
    'Adventure',
    'Animation',
    'Documentary',
    'Comedy',
    'Crime',
    'Documentary',
    'Drama',
    'Family',
    'Fantasy',
    'History',
    'Horror',
    'Music',
    'Mystery',
    'Romance',
    'Science Fiction',
    'Thriller',
    'War',
    'Western'
  ]
};


const GenerationType = () => {
  const navigate = useNavigate();
  const userHash = localStorage.getItem("userHash");
  const userPhone = localStorage.getItem("userPhone");
  const movieData = {
    genres: genres,
    type: null
  };
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [isGeneratedLimit, setIsGeneratedLimit] = useState(false);
  const usedAttemptsDaily = localStorage.getItem("generatedAttemptsDaily");
  const cardFiltersRef = useRef(null);
  const cardRandomRef = useRef(null);


  useEffect(() => {
    scrollToTop();
  }, []);


  useEffect(() => {
    if (usedAttemptsDaily === "5") {
      setIsGeneratedLimit(!isGeneratedLimit);
    }
  }, [usedAttemptsDaily]);


  const generateRandomMoviesSet = async () => {
    await animateButtonPress(cardRandomRef, styles.pressed);
    setIsLoading(true);

    const serverData = await ServerRequest.createMovieData(movieData, userHash, userPhone);
    const parsedServerData = await serverData.json();

    if (parsedServerData.code === 200) {
      dispatch(getGeneratedMovies(parsedServerData.movies));

      if (parsedServerData['generation_attempts'] !== null) {
        localStorage.setItem("generatedAttemptsDaily", parsedServerData['generation_attempts']);
      }

      navigate(Routes.movies);
      setIsLoading(false);
    } else if (
      parsedServerData.code === 405 ||
      parsedServerData.code === 404 ||
      parsedServerData.code === 401 ||
      parsedServerData.code === 500 ||
      parsedServerData.code === 504
    ) {
      setIsLoading(false);
    }
  };


  const handleNavigate = async () => {
    await animateButtonPress(cardFiltersRef, styles.pressed);
    navigate(Routes.preferences);
  };


  return (
    <section className={styles["section_wrapper"]}>
      <Loader isLoading={isLoading}/>
      <p className={styles.title}>
        {texts["generation-type"]["title-first-part"]} <br/>
        {texts["generation-type"]["title-second-part"]}
      </p>
      <div className={styles['cards-container']}>

        <div ref={cardFiltersRef}
             className={`${styles['personal-selection-card']}
                         ${isGeneratedLimit && styles['selection-card-disabled']}`}
             onClick={handleNavigate}>
          <div className={styles['card-text-container']}>
            <div className={styles["card-text-title"]}>
              {texts["generation-type"]["personal-card-title-first-part"]} <br/>
              {texts["generation-type"]["personal-card-title-second-part"]} <br/>
            </div>
            <div className={styles['card-text-description']}>
              {texts["generation-type"]["personal-card-description"]}
            </div>
          </div>
          <img className={styles['generation-type-img']}
               src={require("./img/personal-selection-img.svg").default}
               alt="card for generation"/>
        </div>

        <div ref={cardRandomRef}
             className={`${styles['random-selection-card']}
                         ${isGeneratedLimit && styles['selection-card-disabled']}`}
             onClick={generateRandomMoviesSet}>
          <div className={styles['card-text-container']}>
            <div className={styles["card-text-title"]}>
              {texts["generation-type"]["random-card-title-first-part"]} <br/>
              {texts["generation-type"]["random-card-title-second-part"]} <br/>
            </div>
            <div className={styles['card-text-description']}>
              {texts["generation-type"]["random-card-description"]}</div>
          </div>
          <img className={styles['generation-type-img']}
               src={require("./img/random-selection-img.svg").default}
               alt="card for generation"/>
        </div>

      </div>
    </section>
  );
}

export default GenerationType;